module.exports = "<legend class=layout__group__legend>{{name}}</legend> <div class=js-container-region></div>";


//////////////////
// WEBPACK FOOTER
// ../src/layout/group/group.hbs
// module id = 701
// module chunks = 0